module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.solutionDetail.elements) ? _c('div', {
    staticClass: "landing-detail-solutions"
  }, [_c('hero', {
    attrs: {
      "props": _vm.solutionDetail.elements,
      "heroHome": false
    }
  }), _vm._v(" "), _c('section', {
    class: {
      enhanced: _vm.solutionDetail.elements.enhanced_template.value.length > 0
    },
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inside row"
  }, [(_vm.solutionDetail.elements.our_take_description) ? _c('div', {
    staticClass: "container-fluid our-takes"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(_vm.solutionDetail.elements.enhanced_template.value.length == 0) ? _c('h2', [_vm._v("Our Take")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      intro_text: _vm.solutionDetail.elements.enhanced_template.value.length > 0
    },
    domProps: {
      "innerHTML": _vm._s(_vm.solutionDetail.elements.our_take_description.value)
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.solutionDetail.elements.enhanced_template.value.length > 0) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block big-ideas-section col-xs-12 no-gutters",
    attrs: {
      "id": "big-ideas"
    }
  }, [_c('div', {
    staticClass: "inside row"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\tShouldn’t you expect big execution, too?\n\t\t\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row icons"
  }, [_c('div', {
    staticClass: "col-sm-3 area"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/ux-design.svg"
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 area"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/web-mobile-dev.svg"
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 area"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/crm-market.svg"
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 area"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/analytics.svg"
    }
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])]), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "col-xs-12 no-gutters expertise",
    attrs: {
      "id": "expertises"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.approachs.length) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('h2', {
    class: {
      enhanced: _vm.solutionDetail.elements.enhanced_template.value.length > 0
    },
    attrs: {
      "id": "scrollHere"
    }
  }, [_vm._v("Expertise")]), _vm._v(" "), (_vm.solutionDetail.elements.columns.value.length != 0) ? _c('div', {
    staticClass: "accordions",
    class: {
      'row': _vm.solutionDetail.elements.columns.value.length != 0
    }
  }, _vm._l((_vm.approachs), function(approach) {
    return _c('div', {
      class: ['accordion', {
        'col-md-12': _vm.solutionDetail.elements.columns.value[0].name == '1'
      }, {
        'col-md-6': _vm.solutionDetail.elements.columns.value[0].name == 2
      }, {
        'col-sm-6 col-md-4': _vm.solutionDetail.elements.columns.value[0].name == 3
      }]
    }, [_c('h4', {
      staticClass: "gtm_Competency-Expand"
    }, [_vm._v(_vm._s(approach.title.value) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "accordion-content",
      domProps: {
        "innerHTML": _vm._s(approach.description.value)
      }
    })])
  }), 0) : _c('div', {
    staticClass: "accordions"
  }, _vm._l((_vm.approachs), function(approach) {
    return _c('div', {
      staticClass: "accordion"
    }, [_c('h4', {
      staticClass: "gtm_Competency-Expand"
    }, [_vm._v(_vm._s(approach.title.value) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "accordion-content",
      domProps: {
        "innerHTML": _vm._s(approach.description.value)
      }
    })])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), (_vm.relatedWorks.length) ? _c('section', {
    staticClass: "content-works container-fluid col-xs-12",
    attrs: {
      "id": "section"
    }
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Related Work")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_vm._v(_vm._s(_vm.pageSolution.related_work_description.value))]), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.relatedWorks,
      "boxlimit": 4,
      "showViewAll": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.relatedArticles.length) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles container-fluid col-xs-12"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Insights, commentary and news")]), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.relatedArticles,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showCategory": true,
      "showViewAll": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('contact', {
    attrs: {
      "contactFormInfo": _vm.contactFormInfo
    }
  }), _vm._v(" "), (_vm.quote) ? _c('quote', {
    attrs: {
      "quoteData": _vm.quote
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("At Marcus Thomas, we’re about creating value, not messages; experiences, not just ads. Take a look at some other examples of our work in this area.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("User Experience Design")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Customer journey map development")]), _vm._v(" "), _c('li', [_vm._v("Experience maps")]), _vm._v(" "), _c('li', [_vm._v("Low- and high-fidelity wireframing")]), _vm._v(" "), _c('li', [_vm._v("Static and functional prototyping")]), _vm._v(" "), _c('li', [_vm._v("Live and web-based UX testing")]), _vm._v(" "), _c('li', [_vm._v("Branded User Interface design")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Enterprise Web & Mobile Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Web and mobile site development")]), _vm._v(" "), _c('li', [_vm._v("Custom web and mobile apps")]), _vm._v(" "), _c('li', [_vm._v("CMS and eCommerce implementation")]), _vm._v(" "), _c('li', [_vm._v("Promotion/content updates, maintenance")]), _vm._v(" "), _c('li', [_vm._v("Outsourcing, staff augmentation and managed services")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("CRM / Marketing Automation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Salesforce Marketing Cloud consulting and implementation")]), _vm._v(" "), _c('li', [_vm._v("Salesforce Sales and Service Cloud integrations")]), _vm._v(" "), _c('li', [_vm._v("Third-party CRM integrations (MS Dynamics, Sugar CRM)")]), _vm._v(" "), _c('li', [_vm._v("Custom Salesforce Marketing Cloud apps")]), _vm._v(" "), _c('li', [_vm._v("Custom Salesforce Journey Builder activities")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Analytics & Performance Optimization")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Measurement strategy design")]), _vm._v(" "), _c('li', [_vm._v("Website tracking implementation")]), _vm._v(" "), _c('li', [_vm._v("End-to-end campaign measurement and reporting")]), _vm._v(" "), _c('li', [_vm._v("Cross-channel and multi-touch attribution")]), _vm._v(" "), _c('li', [_vm._v("Custom dashboard development in Tableau and Data Studio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/logo-kentico.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/acquia.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/salesforce.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/google-cloud.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f907a174","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/SolutionDetail.vue
// module id = 1555
// module chunks = 0